import './App.scss'
import Api, { ApiNonce } from './Api'
import { useEffect, useState } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import Form from './components/form/Form'
import Overview from './components/overview/Overview'
import Actions from './components/actions/Actions'
import Requirements from './components/requirements/Requirements'
import Details from './components/details/Details'
import calculateLoan from './components/helpers/CalcHelper'
import FormHelper from './components/helpers/FormHelper'

function App () {
  const [loading, setLoading] = useState(true)
  const [purposes, setPurposes] = useState([])
  const [purpose, setPurpose] = useState('')
  const [member, setMember] = useState(0)
  const [id, setId] = useState(0)
  const [quote, setQuote] = useState('')
  const [amount, setAmount] = useState(0)
  const [period, setPeriod] = useState(1)
  const [interval, setInterv] = useState(2)
  const [actions, setActions] = useState({})
  const [purposeData, setPurposeData] = useState(FormHelper.purposeDataDefault)

  let apr = purposeData.lp_apr
  let rate = purposeData.lp_nominal_rate
  let loan = {
    mrepay: 0,
    tcredit: 0,
    trepay: 0
  }

  useEffect(() => {
    if (loading && purposes.length === 0) {
      let _purpose = new URLSearchParams(window.location.search).get('type')

      const selectedPurposes = document.getElementById('root_calculator').getAttribute('data-purpose')
      const purposeFilter = selectedPurposes ? selectedPurposes.split(',').map(str => str.trim()) : []

      Api
        .getVariables()
        .then(data => {
          if (data && data.calc_settings_loan_purpose && data.calc_settings_loan_purpose.length) {
            let _purposes = data.calc_settings_loan_purpose

            // Filter logic based on purposeFilter and cl_private
            _purposes = _purposes.filter((purpose) => {
              if (purposeFilter.length > 0) {
                // If purposeFilter is not empty, include purposes in purposeFilter
                return purposeFilter.includes(purpose.lp_id.toString())
              } else {
                // If purposeFilter is empty, exclude items where cl_private is true
                return !purpose.cl_private
              }
            })

            _purposes.sort((a, b) => purposeFilter.indexOf(a.lp_id) - purposeFilter.indexOf(b.lp_id))
            console.log(_purposes)
            setPurposes(_purposes)

            _purpose = FormHelper.getPurposeId(_purposes, _purpose)
            setPurpose(_purpose)

            setActions({
              connection: data.calc_settings_connection_url,
            })

            const _purposeData = FormHelper.parsePurposeData(_purposes[_purpose])
            setPurposeData(_purposeData)
          }
          setLoading(false)
        })
    }
  }, [loading])

  useEffect(() => {
    if (purposes && purposes.length && purposes[purpose]) {
      setAmount(0)
      setPeriod(0)

      const _purposeData = FormHelper.parsePurposeData(purposes[purpose])
      setAmount(_purposeData.lp_amount_default)
      setPeriod(_purposeData.lp_term_default)
      setPurposeData(_purposeData)
      setPurposeData(purposes[purpose])
    }
  }, [purpose, purposes])

  if (amount && period && interval && rate) {
    loan = calculateLoan(amount, period, interval, rate)
  }

  const requestQuoteHandler = () => {
    setLoading(true)
    const _purpose = purposeData.lp_title
    Api
      .requestQuote({ ...{ apr: apr, member: member, purpose: _purpose, id: id }, ...loan })
      .then(data => {
        if (data && data.id && data.quote) {
          setId(data.id)
          setQuote(data.quote)
        }
        setLoading(false)
      })
  }
  const excerpt = purposeData.lp_excerpt
  return (
    <div className="calc-wrapper">
      {loading ? (<>
        <Box className="calc-loader">
          <CircularProgress />
        </Box>
      </>) : (<>
        {purposes && purposes.length ? (<>
            <div className="calc-grid">
              <div className="grid-left">
                {quote ? (
                  <Overview {...{ ...{ apr, quote, setQuote, excerpt }, ...loan, ...{ interval } }} />
                ) : (
                  <Form
                    purposes={purposes}
                    values={{ apr, member, purpose, amount, period, interval }}
                    setters={{ setMember, setPurpose, setAmount, setPeriod, setInterv }}
                    purposeData={purposeData}
                  />
                )}
              </div>
              <div className="grid-right">
                {quote ? (<Requirements {...{}} />) : (
                  <Details {...{ ...{ apr, excerpt }, ...loan, ...{ interval } }} />)}
              </div>
            </div>
            <Actions {...{
              loading,
              setLoading,
              actions,
              quote,
              amount,
              period,
              rate,
              purposes,
              purpose,
              requestQuoteHandler,
              interval
            }} />
          </>
        ) : (<><Typography variant="p">Empty</Typography></>)}
      </>)}
    </div>
  )
}

export default App
